var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',[_c('div',{staticClass:"pc-tip",attrs:{"slot":"pc"},slot:"pc"},[_vm._v("请使用移动端打开")]),_c('MobilePage',_vm._b({attrs:{"slot":"mobile"},slot:"mobile"},'MobilePage',_vm.landingProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }